<template>
  <div class="container">
    <img :src="item.src" />
    <span class="title">{{$t(item.title)}}</span>
    <span class="detail">{{$t(item.detail)}}</span>
  </div>
</template>

<script>
export default {
  
  props: ['item'],

}
</script>

<style lang="less" scoped>

.container{
  display: flex;
  flex-direction: column;
  width: 500px;

  img{
    width: 500px;
    height: 280px; 
    object-fit: contain;
  }
  .title{
    color: #061E34;
    font-size: 25px; 
    margin-top: 30px;
    line-height: 1.2;
  }
  .detail{
    color: #9A9A9A;
    font-size: 20px; 
    margin: 25px 50px;
    line-height: 35px;
    text-align: left;
  }
}

@media only screen and (max-width: 768px) {
  .container{
    width: 300px; /*no*/
    img{
      width: 300px; /*no*/
      height: 170px;/*no*/ 
      object-fit: contain;
    }

    .title{
      font-size: 20px;/*no*/
    }

    .detail{
      font-size: 15px; /*no*/
      line-height: 25px;/*no*/
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/SolutionItem.vue